import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WaterLabMainComponent,LabRequestsComponent, ShippingManifestComponent, LabResultsComponent, LabActionItemComponent } from '../components';

const routes: Routes = [
  {
    path: '',
      component: WaterLabMainComponent,
      children: [
        { path: '', component: LabActionItemComponent,data: {  title: "Lab Action Items" } },
        { path: 'LabRequest', component: LabRequestsComponent, data: {  title: "Lab Request" }},
        { path: 'ShippingManifest', component: ShippingManifestComponent, data: {  title: "Shipping Manifest" }},
        { path: 'LabResults', component: LabResultsComponent,data: {  title: "Lab Results" } },
      ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WaterLabRoutingModule { }
